module.exports = __webpack_public_path__ + "img/4PaystackLogo.93fc846f.png";